const toggle = document.querySelector("#navbarToggle");
const navbarDrawer = document.querySelector("#navbarDrawer");

function navToggle(e) {
  document.body.classList.toggle("navbar-open");
  // console.log("This is the click event", e);
}

if (toggle) {
  toggle.addEventListener("click", navToggle);
}

module.exports = {
  navToggle,
};
